import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Same helper as the storefront: conditional classes, with Tailwind conflicts resolved. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** `229900` → `"₹2,299"`. Matches arrow-be's formatter exactly. */
const rupees = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatMinor = (minor: number): string => rupees.format(minor / 100);

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
